import { render, staticRenderFns } from "./ReportWishlist.vue?vue&type=template&id=21158668&"
import script from "./ReportWishlist.vue?vue&type=script&lang=js&"
export * from "./ReportWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports